var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBioData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75971 10.4999H51.2361C54.1425 10.4999 56.5 12.8163 56.5 15.6731V42.8267C56.5 45.6852 54.1425 47.9999 51.2361 47.9999H9.75971C6.85525 47.9999 4.5 45.6854 4.5 42.8267V15.6731C4.5 12.8168 6.85525 10.4999 9.75971 10.4999ZM32.9005 37.987H43.3756V34.5408H32.9005V37.987ZM32.9002 30.3621H49.9405V26.9159H32.9002V30.3621ZM32.9002 22.7371H49.9405V19.2909H32.9002V22.7371ZM23.313 19.3889C22.5174 18.6095 21.4377 18.1713 20.3127 18.1713L20.3125 18.1714C19.1887 18.1776 18.1131 18.6178 17.3186 19.3952C16.5251 20.1735 16.0758 21.2272 16.0695 22.3283C16.0695 23.4306 16.5166 24.4884 17.3123 25.2678C18.108 26.0472 19.1876 26.4854 20.3127 26.4854C21.4377 26.4854 22.5175 26.0473 23.313 25.2678C24.1086 24.4883 24.5559 23.4306 24.5559 22.3283C24.5559 21.2261 24.1087 20.1683 23.313 19.3889ZM16.2705 29.5886C13.7386 30.6742 11.7854 32.7476 10.8835 35.3076C10.7551 35.6478 10.8488 36.0303 11.1192 36.2777C13.57 38.5891 16.8398 39.8799 20.2421 39.8799C23.6444 39.8799 26.914 38.5892 29.365 36.2777C29.6354 36.0303 29.728 35.6478 29.6007 35.3076C28.6979 32.7476 26.7456 30.6743 24.2137 29.5886C21.6818 28.5019 18.8014 28.5019 16.2705 29.5886Z",
    fill: "url(#paint0_linear_1591_47471)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1591_47471",
    x1: 30.5,
    y1: 21.0468,
    x2: 30.5,
    y2: 37.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2193B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DD5ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBioData);
export default __webpack_public_path__ + "static/media/BioData.af80c267dfb1dbda0c23137582922d04.svg";
export { ForwardRef as ReactComponent };